export default __webpack_public_path__ + "static/media/CIALIS-TOTAL_V012-compressed.f405a631.mov";